(function () {
	angular
		.module('trackeye')
		.factory('TagService', TagService);

	TagService.$inject = ["Echotag", "C4ApiService", "$q"];

	function TagService(Echotag, api, $q) {
		var init = false,
			echotags = {},
			exports = {};


		exports.newEchotag = function () {
			return new Echotag();
		};

		exports.saveEchotags = function () {

		};

		exports.getEchotagsByUuid = function (uuid) {
			return echotags[uuid] || [];
		};

		exports.getEchotagById = function (uuid, id) {
			if (!echotags[uuid])
				return undefined;

			return echotags[uuid].find(function (tag) {
				return tag.getId() === id;
			});
		};

		/**
		 * @param {Device} device
		 * @returns {Promise}
		 */
		exports.fetch = function (device) {
			echotags[device.getUuid()] = [];

			return api.forward('get', '/units/' + device.id + '/flexws/rftags', {}, undefined, true).then(function (resp) {
				resp.data.forEach(function (data) {
					var echotag = new Echotag();

					echotag.populate(data, false);
					echotags[device.getUuid()].push(echotag);
				});
			}, angular.noop);
		};

		/**
		 * Saves an echotag for a device, if it's a new tag, the devices
		 * echolist is updated.
		 *
		 * @param {Device} device
		 * @param {Echotag} tag
		 */
		exports.saveEchotag = function (device, tag) {
			var defer = $q.defer();

			if (!tag.getModel()) {
				fetchModel(tag).then(function() {
					saveTag(device, tag, defer);
				},function () {
					defer.reject({model:404})
				})
			} else {
				saveTag(device, tag, defer);
			}

			return defer.promise;
		};

		exports.deleteEchotag = function (device, tag) {
			var defer = $q.defer();

			api.forward('delete', '/units/' + device.getUuid() + '/flexws/rftags?method=delete&tag_id=' + tag.getId()).then(function () {
				var echolist = echotags[device.getUuid()].filter(function (echotag) {
					return tag.getId() !== echotag.getId();
				}).map(function (echotag) {
					return echotag.getId();
				});

				api.configSet({
					guid: device.getGuid(),
					lock_rmd: true,
					echo: {
						on: true,
						list: echolist
					}
				});
				exports.fetch(device).then(defer.resolve, defer.reject);
			}, defer.reject);

			return defer.promise;
		};

		function fetchModel (tag) {
			return api.local('get', 'device/model', {
				nodeid: tag.getId()
			},{},true,true).then(function(xhr) {
				tag.tag_model = xhr.getResponseData('model');
			}).finally(function() {
				tag.prefetch = true;
			});
		}

		function saveTag (device, tag, defer) {
			if (!echotags[device.getUuid()])
				echotags[device.getUuid()] = [];

			var deviceTags = echotags[device.getUuid()];

			api.forward('post', '/units/' + device.getUuid() + '/flexws/rftags', [tag.toJSON()],undefined,true,true).then(function () {
				if (tag.isNew()) {
					// If this is a newly added tag, we'll need to update
					// the echolist of the device configuration
					tag.isNew(false);

					deviceTags.push(tag);

					var echolist = deviceTags.map(function (echotag) {
						return echotag.getId();
					});

					api.configSet({
						guid: device.getGuid(),
						lock_rmd: true,
						echo: {
							on: true,
							list: echolist
						}
					}).then(defer.resolve, defer.reject);
				} else {
					defer.resolve();
				}
			}, function(xhr) {
				if (xhr.BadRequest()) {
					defer.reject({model:400});
				} else {
					defer.reject(xhr);
				}
			});
		}

		return exports;
	}
})();